import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AdminEmailsPage from './Pages/AdminEmailsPage';

const AdminEmailsRouter = () => {
    return (
        <Switch>
            <Route default>
                <AdminEmailsPage />
            </Route>
        </Switch>
    );
};

export default AdminEmailsRouter;
